var $04a7af02228fd881$exports = {};
$04a7af02228fd881$exports = {
    "maximum": `Najvi\u{161}e`,
    "minimum": `Najmanje`
};


export {$04a7af02228fd881$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
